import { useRef, useState, useLayoutEffect, useCallback } from 'react';

function getRect(element) {
  return element
    ? element.getBoundingClientRect()
    : { width: 0, height: 0, top: 0, left: 0, right: 0, bottom: 0 };
}

/**
 * Hook para medir el tamaño de un elemento DOM.
 * Devuelve [ref, bounds], donde ref se debe poner en el elemento.
 */
export default function useMeasure() {
  const ref = useRef(null);
  const [bounds, setBounds] = useState({
    width: 0,
    height: 0,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
  });

  const measure = useCallback(() => {
    if (ref.current) {
      setBounds(getRect(ref.current));
    }
  }, []);

  useLayoutEffect(() => {
    measure();
    if (!ref.current) return;

    // Usar ResizeObserver si está disponible
    const observer = new window.ResizeObserver(measure);
    observer.observe(ref.current);

    window.addEventListener('resize', measure);
    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [measure]);

  return [ref, bounds];
}
